<template>
  <div id="Tab1">
    <div class="tab-content student-tabs-content">
      <div>
        <div
          v-if="evaluationServiceTransition.canShow && !isDraft && canEditTab1"
          class="row-group mb-4 mt-5"
        >
          <CustomStatusLink
            :title="
              'Cuestionario Evaluación de Servicios de Transición Post-Secundaria (Indicador 13)'
            "
            :status="serviceTransitionStatus"
            :errors="evaluationServiceErrors"
            :link-to="'/pei/evaluations/servicetransition'"
          />
        </div>
        <div v-if="canShowMedicalPlanConsentStatus" class="row-group mt-4">
          <CustomStatusLink
            :icon="'comment'"
            :title="'Documentación del plan médico del estudiante'"
            :status="getMedicalPlanConsentStatus"
            :link-to="'/student/medicalplan'"
          />
        </div>
        <div
          v-if="showQuestionnaireForStudent && !isDraft && canEditTab1"
          class="row-group mt-4"
        >
          <CustomStatusLink
            :title="'Cuestionario de Intervención PreEscolar (Indicador 7)'"
            :status="questionnaireStatus"
            :errors="questionnaireForStudent"
            :params="statusLinkParams"
            :use-link-name="true"
            :link-to="'peiEvaluationServiceIntervention'"
          />
        </div>
        <div
          v-if="showControversy && !isDraft && canEditTab1"
          class="row-group mt-4"
        >
          <CustomStatusLink
            :icon="'chat'"
            :title="'Cuestionario de Controversia'"
            :status="getControversyStatus"
            :errors="controversyErrors"
            :link-to="'/pei/controversy'"
          />
        </div>
        <!-- showPreviousControversy && !showControversy -->
        <div
          v-if="hasResolution && !isDraft && canEditTab1"
          class="mt-4 row-group"
        >
          <CustomStatusLink
            :icon="'chat'"
            :title="'Cuestionario de Resolucion de Controversia'"
            :status="resolutionStatus"
            :errors="controversyErrors"
            :link-to="`/pei/controversy/resolution`"
          />
        </div>
        <!-- PEI model needs to be rendered before -->
        <sign-section
          v-if="model && (showSignSection || isSigned)"
          :student-sie="model.studentSieId"
          :pei-id="peiId"
          :is-educational-compensatory-services-completed="
            isEducationalCompensatoryServicesCompleted
          "
          @signed="onPeiSigned"
        />

        <div v-if="showEducationalCompensatoryServicesForm">
          <ValidationObserver ref="formTab1" v-slot="{ dirty }">
            <SaveObserver :dirty="dirty">
              <div class="row">
                <div class="col-8">
                  <SectionTitle
                    icon="fas fa-pen-nib"
                    content="Servicios Compensatorios Educativos Durante la Pandemia (16 de marzo de 2020 al 5 de junio de 2020)"
                    container-class="tag-badge-success mt-5 mb-4"
                  />
                </div>
                <div v-if="!isReadOnly" class="col-4">
                  <action-button
                    class="fr px-4 mt-5"
                    text="Guardar"
                    variant="success"
                    @click="saveTab"
                  />
                </div>
              </div>
              <div class="d-flex flex-row mt-3 py-3 px-4 sub-section-info">
                <div class="col-12 pl-0 pt-0 no-border">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <WizardQuestion
                      id="qQuestions"
                      :ref="'question'"
                      v-model="hasNeedCompensation"
                      description="¿El COMPU discutió la necesidad de compensación de servicios educativos por el periodo inicial de la pandemia (16 de marzo de 2020 al 5 de junio de 2020)?"
                      :get-options="getOptions"
                      :is-required="true"
                      :answer-control-type="1"
                      :hide-icon-box="false"
                      :error="errors[0]"
                      :is-disabled="isReadOnly"
                    />
                    <Error
                      v-if="errors && errors.length > 0"
                      variant="no-border"
                      :message="getMessage('R9260055').name"
                    />
                  </ValidationProvider>
                  <div v-if="hasNeedCompensation" class="mt-4">
                    <div>
                      <label class="title">Determinación del COMPU:</label>
                    </div>
                    <div class="col-12 d-flex p-0">
                      <div class="bg-secondary-9 py-3 rounded-right">
                        <ValidationProvider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-radio-button
                            v-model="compuDetermination"
                            name="compuOptions"
                            label=""
                            :options="radioButtonsOptionsCompu"
                            :error="errors[0]"
                            :custom-error-msg="getMessage('R9260054').name"
                            :is-disabled="isReadOnly"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div v-if="compuDetermination">
                      <label class="title">
                        Estrategia que se utilizará para la compensación del
                        servicio educativo:
                      </label>
                      <div class="col-12 p-0">
                        <div class="bg-secondary-9 py-3 rounded-right">
                          <div
                            v-for="(item,
                            idx) in requireServiceCompensationOptions"
                            :key="idx"
                            class="col-12"
                          >
                            <custom-checkbox
                              :id="item.id"
                              :value="item.selected"
                              :text="item.name"
                              @onChange="item.selected = $event"
                            />
                            <div
                              v-if="item.id == 4 && item.selected"
                              class="col-12 pt-0 mt-2 px-0 mx-0 explanation-cta"
                            >
                              <ValidationProvider
                                v-slot="{ errors }"
                                mode="eager"
                                rules="required"
                              >
                                <CustomTextArea
                                  v-model="item.comment"
                                  :disabled="isReadOnly"
                                  label="Comentario:"
                                  :maxlength="3000"
                                  :rows="1"
                                  :custom-error-msg="getMessage('22126').name"
                                  :error="errors[0]"
                                />
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="compuDetermination === false"
                      class="col-12 pt-0 mt-2 px-0 mx-0 explanation-cta"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        mode="eager"
                        rules="required"
                      >
                        <CustomTextArea
                          v-model="comment"
                          :disabled="isReadOnly"
                          label="Comentario:"
                          :maxlength="3000"
                          :rows="1"
                          :custom-error-msg="getMessage('22126').name"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                    <SectionTitle
                      icon="fas fa-file-user"
                      content="Documento"
                      container-class="tag-badge-main-info mt-4 mb-4"
                    />
                    <div class="col-12 pl-0 pt-0">
                      <Document
                        v-model="compuDocument.file"
                        :attachment-id.sync="compuDocument.documentId"
                        :filename="compuDocument.filename"
                        :disabled="isReadOnly"
                        :label-value="compuDocument.documentTypeName"
                        control-name="compuDocument"
                        :rules="
                          isReadOnly || compuDocument.documentId
                            ? ''
                            : 'required'
                        "
                        :accept="'.pdf'"
                        :max-size="10"
                        label="Documento:"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="hasNeedCompensation == false"
                class="d-flex flex-row mt-3 py-3 px-4 sub-section-info"
              >
                <div class="col-12 pl-0 pt-0">
                  <div class="w-100">
                    <Error
                      v-if="compuMessage"
                      variant="mt-2"
                      is-alert-mode
                      :message="compuMessage"
                    />
                  </div>
                </div>
              </div>
            </SaveObserver>
          </ValidationObserver>
        </div>

        <SectionTitle
          icon="fas fa-file-user"
          content="I. Información General del Estudiante"
          container-class="tag-badge-main-info mt-4 mb-4"
        />

        <Error
          v-if="controversyI && controversyI.existControversy"
          is-alert-mode
          :message="
            '<b>Parte en Controversia: </b>' + controversyI.informationMessage
          "
        />

        <SectionTitle
          :has-line="true"
          :content="`Información General del ${peiTypeLabel}`"
          container-class="mb-4"
        />
        <div class="row-group mb-4">
          <div class="row">
            <div class="col-lg-3">Año Académico:</div>
            <div class="col-lg-3">Enmienda:</div>
            <div class="col-lg-3">Creado:</div>
            <div class="col-lg-3">Modificado:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.academicYear }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.generalRevisionNo }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.createdDate | dateFormat }}
                <br />
                {{ model.createdByUser }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.updatedDate | dateFormat }}
                <br />
                {{ model.updateByUser }}
              </span>
            </div>
          </div>
        </div>
        <SectionTitle
          :has-line="true"
          content="Hoja de Cotejo"
          container-class="mb-4"
          v-if="!isPSC"
        />
        <div class="row-group mb-4" v-if="!isPSC">
          <div class="row">
            <div class="col-lg-3">Creado por:</div>
            <div class="col-lg-3">Modificado por:</div>
            <div class="col-lg-3">Creado en:</div>
            <div class="col-lg-3">Modificado en:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.checklistCreateByUser }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.checklistModifyByUser }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.checklistCreateDate | dateFormat }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.checklistModifyDate | dateFormat }}
              </span>
            </div>
          </div>
        </div>
        <SectionTitle
          :has-line="true"
          content="Información del Estudiante"
          container-class="mb-4"
        />
        <div class="row-group mb-4">
          <div class="row">
            <div class="col-lg-3">Nombre:</div>
            <div class="col-lg-3">Idioma:</div>
            <div class="col-lg-3">SIE:</div>
            <div class="col-lg-3">Género:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.student.firstName + ' ' + model.student.lastName }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.student.language }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.studentSieId }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.student.gender | studentGender }}
              </span>
            </div>
          </div>
        </div>
        <div class="row-group mb-4">
          <div class="row">
            <div class="col-lg-3">Nacimiento:</div>
            <div class="col-lg-3">Edad:</div>
            <div class="col-lg-3">SSN:</div>
            <div class="col-lg-3">Tipo:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.student.birthdate | dateFormat }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.student.age }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ ssnFormatt(model.generalStudentSsn) }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.isStudentPublic | studentType }}
              </span>
            </div>
          </div>
        </div>
        <div class="row-group mb-4">
          <div class="row">
            <div class="col-lg-3">Grupo Étnico:</div>
            <div class="col-lg-3">Vocacional:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.student.ethnicCode }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">{{ vocacionalValue }}</span>
            </div>
          </div>
        </div>
        <SectionTitle
          :has-line="true"
          content="Información de Escuela"
          container-class="mb-4"
          v-if="!isPSC"
        />
        <div v-if="!isPSC" class="row-group mb-4">
          <div class="row">
            <div class="col-lg-3">Región:</div>
            <div class="col-lg-3">Distrito:</div>
            <div class="col-lg-3">Municipio:</div>
            <div class="col-lg-3">Escuela:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.regionName }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.districtName }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.municipality }}
              </span>
            </div>
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                {{ model.schoolCode + ' - ' + model.schoolName }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="!isPSC" class="row-group mb-4">
          <div class="row">
            <div class="col-lg-3">Grado:</div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <span class="font-weight-lighter">
                <b>{{ model.schoolGrade }}</b>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SectionTitle } from '@/components/pei/shared';
import CustomStatusLink from '@/components/common/CustomStatusLink';
import SignSection from '@/components/pei/signpei/SignSection';

import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import store from '@/store/index';
import resourcesService from '@/services/resources.js';
import Error from '@/components/common/Error';
import QuestionnaireTypes from '@/utils/constants/questionnairetypes.js';
import peiStatuses from '@/utils/constants/pei/peiStatus.js';
import peiSections from '@/utils/constants/pei/peiSections.js';
import peiTypes from '@/utils/constants/pei/peiTypes.js';
import {
  CustomCheckbox,
  CustomTextArea,
  ActionButton,
} from '@/components/common';
import WizardQuestion from '@/components/pei/WizardQuestion';
import CustomRadioButton from 'custom-radio';
import { Document } from '@/views/humanResources/request/components/tabs/components/tab1';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import objectToFormData from 'object-to-formdata';
import SaveObserver from '@/components/common/SaveObserver';
import DocumentTypes from '@/utils/constants/documentTypes';
import { getConsentByStudent } from '@/services/medical-plan';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import MedicalPlanConsentStatus from '@/utils/constants/medicalPlanConsentStatus';

export default {
  name: 'Tab1',
  mixins: [mixAlert, mixWait],
  components: {
    SectionTitle,
    CustomStatusLink,
    Error,
    SignSection,
    CustomCheckbox,
    CustomTextArea,
    ActionButton,
    WizardQuestion,
    CustomRadioButton,
    Document,
    ValidationProvider,
    ValidationObserver,
    SaveObserver,
  },
  data() {
    return {
      controveryStatus: null,
      tabTitle: 'I. Información del Estudiante',
      Info: {},
      model: {
        student: {},
        peiStatusCode: 0,
      },
      peiId: store.getters.SelectedPei,
      info: {},
      hlQuestionnaire: '',
      showQuestionnaireForStudent: false,
      questionnaireStatus: '',
      showControversy: false,
      showPreviousControversy: false,
      validationMessages: [],
      evaluationServiceTransition: {
        canShow: false,
        isSubmitted: false,
      },
      serviceTransitionStatus: 'Pendiente',
      statusControversyQuestionnaire: 'Pendiente',
      resources: [],
      statusList: [],
      oldStatus: 0,
      resolutionStatus: '',
      isPs: store.getters.getIsPs,
      hasResolution: false,
      peiTypes: peiTypes,
      checkListErrors: [],
      evaluationServiceErrors: [],
      questionnaireForStudent: [],
      controversyErrors: [],
      statusLinkParams: {
        from: 'Pei',
        questionnaireTypes: [
          QuestionnaireTypes.PrePruebaIntervencion,
          QuestionnaireTypes.PostPruebaIntervencion,
        ],
        place: [
          'Inicio',
          'PEI',
          'Crear',
          'Modificar PEI',
          'Cuestionario de Intervención',
        ],
        linkBack: '/pei/detail',
      },
      compuMessage: null,
      compuComment: null,
      hasNeedCompensation: null,
      compuDetermination: null,
      educationalCompensatoryServicesId: null,
      comment: null,
      compuDocument: {
        documentTypeId: DocumentTypes.MinutaServiciosCompensatorios,
        documentTypeName: 'Minuta Servicios Compensatorios',
        selectedDocument: null,
        documentId: null,
      },
      radioButtonsOptionsCompu: [
        {
          label:
            'Requiere compensación del Servicio Educativo por el periodo del 16 de marzo al 5 de junio 2020.',
          value: true,
        },
        {
          label:
            'No Requiere compensación del Servicio Educativo por el periodo del 16 de marzo al 5 de junio 2020.',
          value: false,
        },
      ],
      needEducationalCompensatoryServices: true,
      requireServiceCompensationOptions: [],
      medicalPlanConsent: null,
      medicaidDocumentationWorkflowEnabled: false,
    };
  },
  watch: {
    'model.peiStatusCode': function(val, oldVal) {
      this.oldStatus = oldVal;
    },
    showSignSectionVisibles(newValue) {
      function getSignErrorSection(id) {
        let section = newValue.find((element) => element.id == id);
        return section.errors;
      }

      this.checkListErrors = getSignErrorSection('CheckList');
      this.evaluationServiceErrors = getSignErrorSection('PostScholarEval');
      this.questionnaireForStudent = getSignErrorSection('PreScholar');
      this.controversyErrors = getSignErrorSection('Controversy');
    },
    async showSignSection(newValue) {
      if (newValue && this.isPs) {
        await this.canGoToPeiFundsAvailability();
      }
    },
  },
  computed: {
    peiTypeLabel() {
      const flag = store.state.pei.configUnilateralFlag;
      const map = {
        '0': 'PEI',
        '1': 'PS',
        '2': 'PSC',
      };
      return map[flag] || '';
    },
    isPSC() {
      return store.state.pei.configUnilateralFlag == '2';
    },
    ...mapGetters({
      showSignSection: 'getVisiblePeiSignSection',
    }),
    isDraft() {
      return store.getters.SelectedPeiStatus == 1;
    },
    isSigned() {
      return this.model.peiStatusCode == 280;
    },
    vocacionalValue() {
      return this.model.vocational ? 'Si' : 'No';
    },
    controversyI() {
      return store.getters.getPeiControversies(peiSections.I);
    },
    showSignSectionVisibles() {
      return this.$store.state.peiTab1.signSectionVisibles;
    },
    getControversyStatus() {
      return this.controveryStatus || 'Pendiente';
    },
    canEditTab1() {
      return store.getters.HasPermission('pei.editTab1');
    },
    canShowMedicalPlanConsentStatus() {
      return (
        (this.model.peiStatusCode == parseInt(peiStatuses.Borrador) ||
          this.model.peiStatusCode == parseInt(peiStatuses.Completado)) &&
        this.medicaidDocumentationWorkflowEnabled &&
        this.canEditTab1
      );
    },
    isReadOnly() {
      return (
        this.model.peiStatusCode == parseInt(peiStatuses.Firmado) ||
        (this.model.peiStatusCode == parseInt(peiStatuses.Completado) &&
          this.isEducationalCompensatoryServicesCompleted)
      );
    },
    showEducationalCompensatoryServicesForm() {
      return this.needEducationalCompensatoryServices;
    },
    isEducationalCompensatoryServicesCompleted() {
      return !!(
        !this.needEducationalCompensatoryServices ||
        (this.needEducationalCompensatoryServices &&
          this.educationalCompensatoryServicesId)
      );
    },
    getOptions() {
      return {
        invalid: false,
        options: [
          {
            id: true,
            label: 'Si',
            disabled: this.isReadOnly,
          },
          {
            id: false,
            label: 'No',
            disabled: this.isReadOnly,
          },
        ],
      };
    },
    getMedicalPlanConsentStatus() {
      return this.medicalPlanConsent &&
        (!this.medicalPlanConsent.hasConsent ||
          this.medicalPlanConsent.status.id == MedicalPlanConsentStatus.Signed)
        ? 'Completado'
        : 'Pendiente';
    },
  },
  filters: {
    dateFormat(value) {
      let strDate = '',
        monthNames = [
          'Ene.',
          'Feb.',
          'Mar.',
          'Abr.',
          'May.',
          'Jun.',
          'Jul.',
          'Ago.',
          'Sep.',
          'Oct.',
          'Nov',
          'Dec.',
        ];

      if (value) {
        value = new Date(value);
        let day = value.getDate();
        let monthIndex = value.getMonth();
        let year = value.getFullYear();
        strDate = day + ' /' + monthNames[monthIndex] + ' /' + year;
      }

      return strDate;
    },
    peiIdFormat(value) {
      return value ? value.substring(0, 4) + ' - ' + value.substring(4) : '';
    },
    studentGender(value) {
      let gender = 'Masculino';

      if (value == 'F') gender = 'Femenino';

      return gender;
    },
    studentType(value) {
      let type = 'Privado';

      if (value) type = 'Público';

      return type;
    },
  },
  activated() {
    store.commit('setSaveBtnVisibility', false);
  },
  created() {
    this.loadValidationMessages();
    this.loadResources();
  },
  async mounted() {
    this.Info = this.$attrs.Info;
    this.$store.dispatch('setVisiblePeiSignSection', false);
    this.getStrategy();
    await this.getPei();
    await this.getSysParams();
    if (this.medicaidDocumentationWorkflowEnabled) {
      await this.getMedicalPlanConsent();
    }
    this.getControversies();
    let isAmendment = this.$route.query.amendmentSuccess != undefined;
    if (isAmendment) {
      this.ShowToast(
        'Notificación',
        'Los datos fueron guardados exitosamente.',
        'success'
      );
    }
    this.compuMessage =
      'Se identificó que el estudiante estuvo activo en el programa de Educación Especial en el periodo del 16 de marzo de 2020 al 5 de junio de 2020 y en que en su PEI tenía servicios educativos para dicho periodo. Tomando en cuenta lo anterior es necesario que el Comité de Programación y Ubicación (COMPU) discuta si conforme las necesidades actuales del estudiante, este requiere compensación de servicios educativos por el servicio no ofrecido según antes expuesto.';
  },
  methods: {
    async onPeiSigned() {
      await this.getPei();
    },
    async getControversies() {
      // await for getPei for there state.
      // Get controversies only in signed or signed status with controversies.
      if (
        store.getters.SelectedPeiStatus != peiStatuses.Firmado &&
        store.getters.SelectedPeiStatus != peiStatuses.SignedWithControversy
      ) {
        return;
      }

      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(`/api/pei/${this.peiId}/controversies`)
          .then((res) => {
            store.dispatch('setPeiControversies', res.data);
            resolve(res.data);
          })
          .catch((err) => {
            this.response = err;
          });
      });

      return promise;
    },
    async canGoToPeiFundsAvailability() {
      let result = await this.$ApiGet(
        '/api/pei/cangotopeifundsavailability?peiid=' + this.model.peiId
      );

      if (result.data) {
        this.$router.push('/pei/AvailabilityFunds');
      }
    },
    async getPei() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet('/api/pei/getpeitab1?peiId=' + self.peiId)
          .then((res) => {
            self.model = res.data;
            if (res.data) {
              let selectedPeiInfo = {
                peiStatusCode: res.data.peiStatusCode,
                peiStatusCodeDescription: res.data.peiStatusDescription,
                peiLocationRejected: res.data.configLocationRejectFlag,
                configUnilateralFlag: res.data.unilateralFlag,
                prescholarFlag: res.data.prescholarFlag,
                extendedSchoolYearFlag: res.data.extendedSchoolYearFlag,
                otherServTechAssistEquipFlag:
                  res.data.otherServTechAssistEquipFlag,
                controversies: null,
                transitionServicesFlag: res.data.transitionServicesFlag,
                ageAmt: res.data.ageAmt,
                checklistStatusCode: res.data.checklistStatusCode,
                academicYearId: res.data.configAcademicYearId,
                academicYear: res.data.academicYear,
              };
              self.$store.dispatch('setSelectedPeiInfo', selectedPeiInfo);
              self.$store.dispatch('setPeiTab2Information', res.data);
              if (
                res.data.educationalCompensatoryServices &&
                res.data.educationalCompensatoryServices.id
              ) {
                self.educationalCompensatoryServicesId = res.data
                  .educationalCompensatoryServices.hasNeedCompensation
                  ? res.data.educationalCompensatoryServices.id
                  : null;
                self.hasNeedCompensation =
                  res.data.educationalCompensatoryServices.hasNeedCompensation;
                self.comment = res.data.educationalCompensatoryServices.comment;
                self.compuDocument.documentId =
                  res.data.educationalCompensatoryServices.document.documentId;
                self.compuDocument.filename =
                  res.data.educationalCompensatoryServices.document.filename;
                self.compuDetermination =
                  res.data.educationalCompensatoryServices.compuDetermination;

                res.data.educationalCompensatoryServices.strategy.forEach(
                  (item) => {
                    var strategy = self.requireServiceCompensationOptions.find(
                      (x) =>
                        x.id == item.strategyForEducationalServiceCompensationId
                    );
                    strategy.selected = true;
                    strategy.comment = item.comment;
                  }
                );
              }
              self.needEducationalCompensatoryServices =
                res.data.needEducationalCompensatoryServices;
            }

            self.loadStatuses(self.model.peiStatusCode);

            if (
              self.model.peiStatusCode === 3 ||
              self.model.peiStatusCode === 280
            ) {
              self.canShowTransitionQuestionnaire();
              self.CanShowQuestinnarieLink();
              if (store.state.pei.configUnilateralFlag != '1') {
                self.CanShowControversyLink();
              }
            }

            if (self.model.generalClosedDate) {
              self.model.generalClosedDate = new Date(
                self.model.generalClosedDate
              );
            }
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });

      return promise;
    },
    loadValidationMessages() {
      const messageCodes = ['0529', '22126', 'R9260054', 'R9260055'];
      let promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    getMessage(code) {
      let message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
    canShowTransitionQuestionnaire() {
      let self = this;
      self
        .$ApiGet('/api/pei/canshowtransitionquestionnaire?peiid=' + self.peiId)
        .then((res) => {
          self.hlQuestionnaire = self.getMessage('0529').name;
          self.serviceTransitionStatus = res.data.isSubmitted
            ? 'Completado'
            : 'Pendiente';
          self.evaluationServiceTransition = res.data;

          if (
            self.evaluationServiceTransition.canShow &&
            !self.evaluationServiceTransition.isSubmitted
          ) {
            self.model.generalClosedDate = null;
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.data) {
            self.ShowToast('', error.response.data.message, 'error');
          } else {
            self.ShowToast(
              '',
              'Ha ocurrido un error mientras se procesaba la información.',
              'error'
            );
          }
        });
    },
    async setTransportQuestionnarieNumbers() {
      await this.$ApiPut(
        `/api/pei/settransportquestionnarienumbers/${this.peiId}`
      );
    },
    goToEvaluationServiceTransition() {
      this.$router.push('/pei/evaluations/servicetransition');
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages(['0661']);

      this.LnkControversy = this.resources['0661'];
    },
    CanShowQuestinnarieLink() {
      return this.$ApiGet(
        `/api/pei/${this.peiId}/canShowQuestionnaireForStudent/${this.$store.getters.SelectedStudent.studentId}`,
        false
      )
        .then((res) => {
          if (res.data) {
            this.showQuestionnaireForStudent =
              res.data.canShowQuestionnaireAlert;
            this.questionnaireStatus = res.data.status;
          }
        })
        .catch((err) => {
          this.response = err;
        });
    },

    CanShowControversyLink() {
      return this.$ApiGet(`/api/pei/${this.peiId}/hasControversy`)
        .then((res) => {
          if (res.data) {
            this.showControversy = res.data.hasControversy;
            this.showPreviousControversy = res.data.hasPreviousControversy;
            this.hasResolution = this.showResolutionLink(res.data);
            this.resolutionStatus = res.data.isControversyResolved
              ? 'Completado'
              : 'Pendiente';
            this.controveryStatus = res.data.isControversySubmitted
              ? 'Completado'
              : 'Pendiente';
            store.dispatch('setPreviousPeiId', res.data.previousPeiId);
          }
        })
        .catch((err) => {
          this.response = err;
        });
    },
    showResolutionLink(data) {
      return data.previousPeiId !== '' && data.peiId == '';
    },
    goToControversyForPei() {
      this.$router.push('/pei/controversy');
    },
    async onSelectedDate() {
      await this.canShowTransitionQuestionnaire();
      // await this.setTransportQuestionnarieNumbers();
      if (this.model.unilateralFlag == '1') {
        this.canGoToPeiFundsAvailability();
      }
    },
    loadStatuses(statusCode) {
      this.$ApiGet('/api/pei/statusList?peiStatusCode=' + statusCode)
        .then((res) => {
          if (res.data) {
            this.statusList = res.data;
          }
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async confirmStatusChange(event) {
      let selectedStatus = event.target.value;
      let message =
        '¿Está seguro que quiere modificar el estatus actual del PEI o PS?';
      let isComplete = false;

      if (selectedStatus == peiStatuses.Completado) {
        isComplete = true;
        message =
          '¿Está seguro que quiere modificar el estatus del PEI o PS de “Borrador” a “Completado”?';
      }

      const answer = await mixAlert.methods.ShowCancelModal(
        'Atención',
        message,
        'Sí',
        'No'
      );
      if (!answer) {
        this.model.peiStatusCode = this.oldStatus;
      } else {
        const pei = await this.changeStatus(selectedStatus);

        if (this.model.configLocationRejectFlag == '1' && isComplete && pei) {
          await this.createPSCopy(
            this.model.peiId,
            this.model.configAcademicYearId
          );
        }
      }
    },
    async changeStatus(selectedStatus) {
      if (selectedStatus == peiStatuses.Completado) {
        await this.CanShowQuestinnarieLink();

        if (self.showQuestionnaireForStudent) {
          this.model.peiStatusCode = this.oldStatus;

          return;
        }
      }

      await this.$ApiPost('/api/pei/changeStatus', {
        peiid: this.peiId.toString(),
        statusId: parseInt(selectedStatus),
      })
        .then((res) => {
          if (res.data) self.model = res.data;
        })
        .catch((err) => {
          this.response = err;
          this.model.peiStatusCode = this.oldStatus;
        });

      this.loadStatuses(this.model.peiStatusCode);
      return self.model;
    },
    ssnFormatt(ssn) {
      return ssn
        ? ssn.slice(0, 3) + '-' + ssn.slice(3, 5) + '-' + ssn.slice(5, 9)
        : '';
    },
    async createPSCopy(peiId, configAcademicYearId) {
      return await new Promise((resolve) => {
        this.$ApiPost('/api/pei/createpscopy', {
          PeiId: peiId,
          ConfigAcademicYearId: configAcademicYearId,
        }).then((res) => {
          if (res && res.data != null) {
            resolve(res.data);
          }
        });
      });
    },
    async saveTab() {
      const isValid = await this.$refs.formTab1.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      const formDto = {
        peiId: this.peiId,
        hasNeedCompensation: this.hasNeedCompensation,
        compuDetermination:
          this.compuDetermination == null ? false : this.compuDetermination,
        comment: this.comment,
        strategy: [],
        file: this.compuDocument.file,
      };
      this.requireServiceCompensationOptions
        .filter((x) => x.selected)
        .forEach((item) => {
          formDto.strategy.push({
            strategyForEducationalServiceCompensationId: item.id,
            comment: item.comment,
          });
        });

      const data = objectToFormData(formDto, { indices: true });

      this.$ApiPost('/api/pei/educationalcompensatoryservices', data)
        .then((r) => {
          this.ShowToast(
            this.resources['R03200110'],
            this.resources['R03200109'],
            'success'
          );
          this.educationalCompensatoryServicesId = this.hasNeedCompensation
            ? r.data
            : null;
        })
        .catch((err) => {
          this.ShowToast('', err.response.data.message, 'error');
        });
    },
    async getStrategy() {
      let result = await this.$ApiGet(
        '/api/code/strategyforeducationalservicecompensation'
      );

      this.requireServiceCompensationOptions = result.data;
    },
    async getMedicalPlanConsent() {
      const { data } = await getConsentByStudent(this.model.studentSieId);
      this.medicalPlanConsent = data;
    },
    async getSysParams() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['MedicaidDocumentationWorkflowEnabled'],
      });

      this.medicaidDocumentationWorkflowEnabled =
        data
          ?.find((x) => x.name == 'MedicaidDocumentationWorkflowEnabled')
          ?.staticValue?.toLowerCase() == 'true' ?? false;
    },
  },
};
</script>

<style scoped>
.calendar-fixed-size {
  max-width: 173px;
}

.custom-control-input-fix {
  z-index: 10;
}
</style>
<style scope>
.region-section-header {
  color: #11291b !important;
  background: #f5eee9 0% 0% no-repeat padding-box !important;
  width: 350px;
  height: 35px !important;
  line-height: 35px !important;
}

.region-section-header-title {
  background: #f5eee9 0% 0% no-repeat padding-box !important;
  font: Bold 1.125rem Lato !important;
  text-align: left;
}
.sub-section-info {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 4px;
}

.title {
  font: Bold 18px/28px Lato;
}
.no-border .question-element .item-pane {
  box-shadow: none;
  border-bottom: none;
}
</style>
